import { Navigate } from 'react-router-dom'
import { useAuth } from '@/lib/auth'

type Props = {
  /** Chave da MATRIX (ex.: recrutamento, colaboradores, portal). */
  matrixKey: string
  children: React.ReactNode
}

/** Bloqueia rota se o perfil não tem canView(matrixKey). */
export function RequireModule({ matrixKey, children }: Props) {
  const { canView, homePath, loading, isAuthenticated, isColab } = useAuth()

  if (loading) return <div className="hi-shell-loading">Carregando sessão…</div>
  if (!isAuthenticated) return <Navigate to="/login" replace />

  // Colab: home canônica é o portal (evita dashboard vazio em /app).
  if (matrixKey === 'dashboard' && isColab) {
    return <Navigate to={homePath} replace />
  }

  if (matrixKey === 'dashboard') {
    if (!(canView('dashboard') || canView('command-center') || canView('portal'))) {
      return <Navigate to={homePath} replace />
    }
    return <>{children}</>
  }

  if (!canView(matrixKey)) {
    return <Navigate to={homePath} replace />
  }

  return <>{children}</>
}
